import { localeService } from "../dependencyInjection";

export function useLCID() {
  return localeService.lcid; // Legacy
}